import React from "react";
import { Link } from "react-router-dom";
import siteConfig from "../config/siteConfig";
import "../css/about.scss";

const principles = [
  {
    number: "01",
    title: "Natürlich gedacht",
    text: "Wir wählen Fasern nach ihrem Gefühl auf der Haut, ihrer Herkunft und ihrer Wirkung auf die Umwelt aus.",
  },
  {
    number: "02",
    title: "Fair gemacht",
    text: "Langfristige Partnerschaften und nachvollziehbare Lieferketten gehören für uns zu jedem guten Kleidungsstück.",
  },
  {
    number: "03",
    title: "Lange geliebt",
    text: "Zeitlose Schnitte, sorgfältige Verarbeitung und pflegeleichte Qualitäten machen Mode zu verlässlichen Begleitern.",
  },
];

const journey = [
  {
    title: "Faser",
    text: "Natürliche und bevorzugt zertifizierte Materialien bilden den Anfang.",
  },
  {
    title: "Handwerk",
    text: "Erfahrene Partner verarbeiten sie achtsam und unter fairen Bedingungen.",
  },
  {
    title: "Lieblingsstück",
    text: "Durchdachtes Design schenkt Bewegungsfreiheit und bleibt über Saisons relevant.",
  },
  {
    title: "Weitertragen",
    text: "Gute Pflege, Reparatur und ein zweites Leben verlängern den Wert jedes Teils.",
  },
];

function About() {
  const { brandName, description } = siteConfig;

  return (
    <main className="about">
      <section className="about__hero" aria-labelledby="about-title">
        <div className="about__hero-copy">
          <nav className="about__breadcrumb" aria-label="Brotkrümelnavigation">
            <Link to="/">Startseite</Link>
            <span aria-hidden="true">/</span>
            <span aria-current="page">Über uns</span>
          </nav>
          <p className="about__eyebrow">Kleidung, die Mensch und Natur gut tut</p>
          <h1 id="about-title">Natürlich. Ehrlich. Für lange Zeit.</h1>
          <p className="about__lead">
            {brandName} verbindet moderne, ruhige Gestaltung mit natürlichen
            Materialien und verantwortungsvollem Handeln.
          </p>
        </div>
        <div
          className="about__hero-art"
          role="img"
          aria-label="Abstrakte Landschaft aus natürlichen Formen"
        >
          <span className="about__hero-note">Von der Natur inspiriert</span>
        </div>
      </section>

      <section className="about__intro" aria-labelledby="about-intro-title">
        <div>
          <p className="about__kicker">Unsere Haltung</p>
          <h2 id="about-intro-title">Weniger Kompromisse. Mehr Bewusstsein.</h2>
        </div>
        <div className="about__intro-copy">
          <p>
            Für uns beginnt gutes Design nicht beim Trend, sondern beim
            Material. Wir fragen, wo eine Faser herkommt, wie sie verarbeitet
            wird und wie lange sie Freude bereiten kann.
          </p>
          <p>
            {description ||
              "Zeitgemäße Naturmode entsteht mit Respekt vor Ressourcen, Menschen und dem Alltag derjenigen, die sie tragen."}
          </p>
        </div>
      </section>

      <section
        className="about__principles"
        id="responsibility"
        aria-labelledby="values-title"
      >
        <div className="about__section-heading">
          <p className="about__kicker">Was uns leitet</p>
          <h2 id="values-title">Drei Prinzipien, ein gutes Gefühl</h2>
        </div>
        <div className="about__principle-grid">
          {principles.map((principle) => (
            <article className="about__principle" key={principle.number}>
              <span aria-hidden="true">{principle.number}</span>
              <h3>{principle.title}</h3>
              <p>{principle.text}</p>
            </article>
          ))}
        </div>
      </section>

      <section
        className="about__material-story"
        id="materials"
        aria-labelledby="material-title"
      >
        <div className="about__material-art" aria-hidden="true">
          <span>Bio-Baumwolle</span>
          <span>Leinen</span>
          <span>Schurwolle</span>
          <span>TENCEL™ Lyocell</span>
        </div>
        <div className="about__material-copy">
          <p className="about__kicker">Material ist eine Entscheidung</p>
          <h2 id="material-title">Spürbare Qualität beginnt am Ursprung.</h2>
          <p>
            Natürliche Fasern sind atmungsaktiv, vielseitig und angenehm auf
            der Haut. Wo immer möglich, setzen wir auf kontrollierte Herkunft,
            anerkannte Standards und kurze, nachvollziehbare Wege.
          </p>
          <Link className="about__text-link" to="/shop">
            Kollektion entdecken <span aria-hidden="true">→</span>
          </Link>
        </div>
      </section>

      <section
        className="about__journey"
        id="care"
        aria-labelledby="journey-title"
      >
        <div className="about__section-heading">
          <p className="about__kicker">Unser Weg</p>
          <h2 id="journey-title">Vom Ursprung bis zu dir</h2>
        </div>
        <ol className="about__journey-list">
          {journey.map((step, index) => (
            <li key={step.title}>
              <span className="about__journey-index">
                {String(index + 1).padStart(2, "0")}
              </span>
              <div>
                <h3>{step.title}</h3>
                <p>{step.text}</p>
              </div>
            </li>
          ))}
        </ol>
      </section>

      <section className="about__cta" aria-labelledby="about-cta-title">
        <div>
          <p className="about__kicker">Gemeinsam bewusster</p>
          <h2 id="about-cta-title">Entdecke Kleidung mit Haltung.</h2>
        </div>
        <div className="about__cta-actions">
          <Link className="about__button about__button--primary" to="/shop">
            Jetzt entdecken
          </Link>
          <Link className="about__button about__button--secondary" to="/contact">
            Fragen an uns
          </Link>
        </div>
      </section>
    </main>
  );
}

export default About;
